<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" width="65%">
      <span slot="title" class="code-title">追溯码详情</span>
      <div class="code-search-box">
        <div class="code-search-item">
          <div class="code-search-item-label">追溯码</div>
          <div class="code-search-item-value">
            <el-input
              v-model="queryParam.barcode"
              placeholder="请输入内容"
              size="mini"
              style="font-size: 13px"
              @keyup.enter.native="handleSearch"
            />
          </div>
        </div>
        <div class="code-search-item">
          <div class="code-search-item-label">生产批号</div>
          <div class="code-search-item-value">
            <el-input
              v-model="queryParam.batchNo"
              placeholder="请输入内容"
              size="mini"
              style="font-size: 13px"
              @keyup.enter.native="handleSearch"
              :disabled="batchNoDisabled"
            />
          </div>
        </div>
        <div class="code-search-button">
          <el-button type="primary" size="mini" @click="handleSearch"
            >查询</el-button
          >
          <el-button plain size="mini" @click="handleReset">重置</el-button>
        </div>
      </div>
      <div class="code-table-box">
        <div class="table-box">
          <div class="table-button">
            <el-button
              type="primary"
              size="mini"
              @click="handleExport"
              :loading="buttonLoading"
            >
              <i class="el-icon-download"></i>
              导出
            </el-button>
          </div>
          <div class="table-d">
            <el-table
              v-loading="loading"
              ref="workTableRef"
              :data="tableList"
              stripe
              :header-cell-style="{
                background: '#F0F3F7',
                color: '#2a354e',
                fontWeight: 400,
              }"
              style="width: 100%"
              height="450"
              highlight-current-row
              :row-key="'id'"
              @row-click="handleRowClick"
              size="mini"
            >
              <el-table-column
                prop="barcodeNo"
                label="追溯码"
                width="200"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="commonName"
                label="药品通用名"
                width="200"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="batchNo"
                label="生产批号"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="dosageForm"
                label="剂型"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="drugSpecification"
                label="制剂规格"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="packageSpecification"
                label="包装规格"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="nationalDrugCode"
                label="国家药品标识码"
                width="150"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.nationalDrugCodeException"
                    class="table-exception"
                    @click="handleTableException(scope.row)"
                  >
                    <span>异常</span>
                    <i class="el-icon-arrow-right" />
                  </div>
                  <div v-else>{{ scope.row.nationalDrugCode }}</div>
                </template>
              </el-table-column>

              <el-table-column
                prop="produceDate"
                label="生产日期"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="expiredDateStr"
                label="有效期至"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="quotedHolder"
                label="上市持有人"
                width="250"
              />
              <el-table-column
                prop="produtionEnterpriseName"
                label="生产企业"
                width="250"
              />
            </el-table>
          </div>
          <div class="table-page">
            <div class="table-page-index">当前 {{ paging.index }} 页</div>
            <el-pagination
              :current-page="paging.index"
              :page-size="paging.size"
              layout="total,  prev, pager, next, jumper"
              :total="total"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </el-dialog>

    <TipDialog ref="TipDialogRef" />
  </div>
</template>

<script>
import TipDialog from "@/components/TipDialog/index.vue";

export default {
  name: "Code",
  components: {
    TipDialog,
  },
  props: {},
  data() {
    return {
      dialogCodeVisible: false,
      paging: {
        index: 1,
        size: 100,
      },
      loading: false,
      queryParam: {
        standardCode: "",
        barcode: "",
        batchNo: "",
        orderId: "",
        partitionIndex: "",
        orderTable: "",
        orderDetailId: "",
        enterpriseName: "",
      },
      total: 0,
      tableList: [],
      batchNoDisabled: false,
      selectedRow: null,
      buttonLoading: false,
    };
  },
  created() {},
  methods: {
    handleRowClick(row) {
      this.selectedRow = row;
    },
    async handleExport() {
      this.$confirm("是否确认导出当前列表?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.buttonLoading = true;
        let res = await this.$api.exportCenter.ExportStockBarcodeList({
          ...this.queryParam,
        });
        this.buttonLoading = false;
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = `追溯码_${new Date().toISOString().slice(0, 10)}.xls`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.$notify({
          title: "导出成功!",
          type: "success",
          message: "选中内容导出成功。",
          dangerouslyUseHTMLString: true,
          position: "bottom-right",
          duration: 4000,
          customClass: "notify-success-title",
        });
      });
    },
    handleTableException(row) {
      this.$refs.TipDialogRef.show({
        title: row.exceptionTitle,
        content: row.exceptionContent,
      });
    },
    async show(value) {
      this.dialogCodeVisible = true;
      this.loading = true;
      this.queryParam.standardCode = value.standardCode;
      this.queryParam.partitionIndex = value.partitionIndex;
      this.queryParam.batchNo = value.batchNo;
      if (value.batchNo) {
        this.batchNoDisabled = true;
      } else {
        this.batchNoDisabled = false;
      }
      this.queryParam.orderId = value.orderId;
      this.queryParam.orderTable = value.orderTable;
      this.queryParam.orderDetailId = value.orderDetailId;
      this.queryParam.enterpriseName = value.enterpriseName;
      const { data, extended } = await this.$api.stock.GetStockBarcodeList({
        ...this.queryParam,
        paging: this.paging,
      });
      this.loading = false;
      this.tableList = data;
      this.total = extended.paging.total;
    },
    async getList() {
      this.loading = true;
      const { data, extended } = await this.$api.stock.GetStockBarcodeList({
        ...this.queryParam,
        paging: this.paging,
      });
      this.loading = false;
      this.tableList = data;
      this.total = extended.paging.total;
    },
    handleSearch() {
      this.paging.index = 1;
      this.getList();
    },
    handleReset() {
      this.queryParam.barcode = "";
      if (!this.batchNoDisabled) {
        this.queryParam.batchNo = "";
      }
    },
    handleSizeChange(value) {
      this.paging.index = 1;
      this.paging.size = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.paging.index = value;
      this.getList();
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
@import "./index.scss";
</style>
